import { render, staticRenderFns } from "./order-data.vue?vue&type=template&id=3fc01ec6&"
import script from "./order-data.vue?vue&type=script&lang=js&"
export * from "./order-data.vue?vue&type=script&lang=js&"
import style0 from "./order-data.vue?vue&type=style&index=0&id=3fc01ec6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports